import { render, staticRenderFns } from "./OTKLicenseActions.vue?vue&type=template&id=f047e2d4&scoped=true"
import script from "./OTKLicenseActions.vue?vue&type=script&lang=js"
export * from "./OTKLicenseActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f047e2d4",
  null
  
)

export default component.exports